import { CellTable } from "@/atoms"
import { TFunction } from "@/hooks/useTranslation"
import { CellWithStatusIndicator } from "@/molecules/CellWithStatusIndicator"
import { getWorkflow } from "@/pages/GovernancePage/applications/workflow/useWorkflow.selector"

type Entity = ReturnType<typeof getWorkflow>["data"][number]

export const NameCell = (t: TFunction) =>
  function NameCellComponent(name: string, record: Entity) {
    return (
      <CellWithStatusIndicator
        truncate
        status={record.isError ? "error" : undefined}
        statusTooltip={t("settings.automatedActions.table.errorTooltip")}
      >
        {CellTable(name, record)}
      </CellWithStatusIndicator>
    )
  }
